import React, { FC, ReactNode } from "react";
import cn from "clsx";
import style from "./Pressable.module.scss";

interface Props {
  children: ReactNode;
  onClick: () => void;
  tag?: "span" | "div";
  className?: string;
}

export const Pressable: FC<Props> = ({
  tag: Tag = "span",
  children,
  onClick,
  className,
}) => {
  return (
    <Tag
      className={cn(style.pressable, className)}
      role="presentation"
      onClick={onClick}
    >
      {children}
    </Tag>
  );
};
